import classNames from "classnames/dedupe";
import React, { FC, ReactNode } from "react";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IAlertProps {
  headerVariant?: "default" | "simple";
  isMultiLiner?: boolean;
  isWarning?: boolean;
  isWarningSimple?: boolean;
  isFocused?: boolean;
  headerContent?: ReactNode;
  bodyContent?: ReactNode;
  footerContent?: ReactNode;
}

const Alert: FC<IAlertProps> = ({
  headerContent,
  bodyContent,
  footerContent,
  headerVariant = "default",
  isFocused,
  isWarning,
  isWarningSimple,
  isMultiLiner,
}) => {
  const headerClasses = classNames("alert-heading", {
    "alert-heading--simple": headerVariant === "simple",
  });

  const alertClasses = classNames(
    "alert",
    {
      "alert alert__multiliner": isMultiLiner,
    },
    {
      "alert--warning": isWarning,
    },
    {
      "alert--warning alert--warning__simple": isWarningSimple,
    },
    {
      "alert--focus": isFocused,
    },
  );

  const headerElement = headerContent ? (
    <div className={headerClasses}>{headerContent}</div>
  ) : null;

  const bodyElement = bodyContent ? (
    <div className="alert-body">{bodyContent}</div>
  ) : null;

  const footerElement = footerContent ? (
    <div className="alert-footer">{footerContent}</div>
  ) : null;

  return (
    <div className={alertClasses} role="alert">
      <div className="alert-wrapper">
        {headerElement}
        {bodyElement}
      </div>
      {footerElement}
    </div>
  );
};

export default Alert;
